import { useState } from "react";
import { Wand2, Quote, CalendarHeart, Copy, Compass, Layers, Wrench, Sparkles } from "lucide-react";
import { toast } from "sonner";

const QUICK_ACTIONS = [
  { slug: "make-this-better", title: "Make This Better", desc: "Improve an existing design while keeping the core idea.", icon: Wand2 },
  { slug: "change-the-phrase", title: "Change the Phrase", desc: "Keep the concept but create a new phrase or variation.", icon: Quote },
  { slug: "make-it-seasonal", title: "Make It Seasonal", desc: "Transform the concept for Halloween, Christmas, Fall, Valentine's Day etc.", icon: CalendarHeart },
  { slug: "next-variation", title: "Find the Next Variation", desc: "Create another original design targeting the same audience.", icon: Copy },
  { slug: "test-new-niche", title: "Test a New Niche", desc: "Adapt the concept for another Etsy audience.", icon: Compass },
  { slug: "build-a-collection", title: "Build a Collection", desc: "Turn one winning concept into multiple coordinated designs.", icon: Layers },
  { slug: "fix-this-design", title: "Fix This Design", desc: "Improve composition, typography, hierarchy or visual execution.", icon: Wrench },
  { slug: "original-spin", title: "Create an Original Spin", desc: "Use the reference as inspiration while creating a clearly new concept.", icon: Sparkles },
];

export default function QuickActionGrid({ onPrefill, prefix = "welcome" }) {
  const [active, setActive] = useState(null);

  const apply = (action) => {
    setActive((a) => (a === action.slug ? null : action.slug));
    onPrefill(`${action.title} — ${action.desc}`);
    toast.success(`${action.title} added to your brief.`);
  };

  return (
    <div>
      <label className="mb-2 block text-xs font-semibold uppercase tracking-wider text-slate-400">
        Creative Shortcuts — tap one to start your brief
      </label>
      <div data-testid={`${prefix}-quick-actions`} className="grid grid-cols-2 gap-2.5 sm:grid-cols-4">
        {QUICK_ACTIONS.map((a) => (
          <button
            key={a.slug}
            type="button"
            data-testid={`${prefix}-quick-action-${a.slug}`}
            onClick={() => apply(a)}
            className={`rounded-xl border px-3 py-3 text-left transition-all duration-200 hover:-translate-y-0.5 hover:border-amber-300 hover:shadow-[0_0_20px_rgba(245,158,11,0.25)] ${
              active === a.slug
                ? "border-amber-400 bg-amber-400/10"
                : "border-amber-400/40 bg-[#070B14]/70"
            }`}
          >
            <a.icon className="h-4 w-4 text-amber-300" />
            <p className="mt-1.5 text-[11px] font-bold leading-tight text-white">{a.title}</p>
            <p className="mt-1 text-[10px] leading-snug text-slate-500">{a.desc}</p>
          </button>
        ))}
      </div>
    </div>
  );
}